import React from 'react';
import {useSelector} from "react-redux";
import {RootState} from "../../store/rootReducer";
import {useGetWorkspaceQuery, usePutWorkspaceMutation} from "../../store/Api";
import {Checkbox, ContextualMenu, ContextualMenuItemType, Icon, IContextualMenuItem} from "@fluentui/react";
import {useApplyToWorkspaceItems} from "./useApplyToWorkspaceItems";
interface IWorkspaceTaxableHeaderProps {
    isExample?: boolean;
}

const WorkspaceTaxableHeader: React.FC<IWorkspaceTaxableHeaderProps> = (props) => {
    const selectedWorkspace = useSelector((state: RootState) => state.settings.selectedWorkspaceId);
    if (selectedWorkspace == null) return <>Is Taxable</>
    return <WorkspaceTaxableEntry workspace={selectedWorkspace} isExample={props.isExample} />
}

interface IWorkspaceTaxableEntryProps {
    workspace: string;
    isExample?: boolean;
}

const WorkspaceTaxableEntry: React.FC<IWorkspaceTaxableEntryProps> = (props) => {
    const workspace = useGetWorkspaceQuery(props.workspace, {skip: !props.workspace || props.workspace.trim().length === 0});
    const [showMenu, setShowMenu] = React.useState<boolean>(false);
    const headerRef = React.useRef<HTMLSpanElement>(null);
    const [patchWorkspace] = usePutWorkspaceMutation();
    const {apply, applying, items} = useApplyToWorkspaceItems(props.workspace);

    // Every line, not just the default: writes isTaxable exactly as the cell's own checkbox does.
    const applyToAll = (taxable: boolean) => {
        if (props.isExample) return;
        setShowMenu(false);
        void apply(taxable ? 'taxable' : 'not taxable', () => true, () => ({isTaxable: taxable}));
    };

    const update = (v: boolean | undefined) => {
        if(props.isExample) return;
        if (workspace.data) {
            patchWorkspace({
                ...workspace.data,
                id: props.workspace,
                defaultTaxable: v,
                documentIsCurrent: false
            });
            setShowMenu(false);
        }
    }
    const getDefaultTaxableHeader = () => {
        if(workspace.data?.defaultTaxable === true) {
            return '(✓)'
        }
        return ''

    }

    const menuItems: IContextualMenuItem[] = [
        {key: 'defaultHeader', itemType: ContextualMenuItemType.Header, text: 'Default for lines without a setting'},
        {
            onRender: () =>
                <div style={{margin: '1em'}}>
                    <Checkbox checked={workspace.data?.defaultTaxable === true}
                              label={'Taxable'}
                        onChange={(e,d) => {
                            if (d != undefined) {
                                update(d)
                            }
                        }}
                    />
                </div>,
            key: 'isTaxable',
        },
        {key: 'divider', itemType: ContextualMenuItemType.Divider},
        {key: 'allHeader', itemType: ContextualMenuItemType.Header, text: `Set every line (${items.length}) to`},
        {key: 'allTaxable', text: 'Taxable', iconProps: {iconName: 'CheckMark'}, disabled: applying || items.length === 0, onClick: () => applyToAll(true)},
        {key: 'allNotTaxable', text: 'Not taxable', iconProps: {iconName: 'Cancel'}, disabled: applying || items.length === 0, onClick: () => applyToAll(false)},
    ]
    return (<>
        <div
            onClick={() => {
                setShowMenu(!showMenu);
            }}
            style={{
                cursor: 'pointer',
                width: '400px',
            }}
        >
            <span ref={headerRef}>
                Taxable {getDefaultTaxableHeader()}
                <ContextualMenu items={menuItems} hidden={!showMenu} target={headerRef} onDismiss={() => setShowMenu(false)}/>
                <Icon iconName={'Edit'} style={{marginLeft: '0.5em'}}/>
            </span>
        </div>
    </>);
}

export default WorkspaceTaxableHeader;